const BACKEND_URL="https://sac.iitpkd.ac.in"

export default BACKEND_URL;
